// extracted by mini-css-extract-plugin
export default {"faqAgentAdvantagesItem":"faqAgentAdvantagesItem_HcRjI","container":"container_My656","image":"image_W7Xdb"};